import { render, staticRenderFns } from "./UserBiddings.vue?vue&type=template&id=15e4f8fc&scoped=true&"
import script from "./UserBiddings.vue?vue&type=script&lang=js&"
export * from "./UserBiddings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15e4f8fc",
  null
  
)

export default component.exports